import { StoreError } from '@/types/storeError.interface';
import { IndexedReleases } from '@/typings';
import {
  createStoreSlice as createSlice,
  type PayloadAction,
} from '@/store/core';
import { RootState } from '../store';

interface ReleaseState {
  loading: boolean;
  error: StoreError | null;
  releases: IndexedReleases;
}

const initialState: ReleaseState = {
  releases: {},
  loading: false,
  error: null,
};

export const releaseSlice = createSlice({
  name: 'release',
  initialState,
  reducers: {
    releaseLoading: state => {
      state.loading = true;
    },
    fetchReleaseSuccess: (state, action: PayloadAction<IndexedReleases>) => {
      state.loading = false;
      state.error = null;
      state.releases = { ...state.releases, ...action.payload };
    },
    fetchReleaseFailure: (state, action: PayloadAction<StoreError>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { releaseLoading, fetchReleaseSuccess, fetchReleaseFailure } =
  releaseSlice.actions;

export const selectRelease = (state: RootState) =>
  state[releaseSlice.name] as typeof initialState;
